function printContent(content, buttons) {
    var printWindow = window.open('', '', 'width=900,height=750');
    var shouldClose = false;
    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(content);
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (isIOS) {
            printWindow.document.write(buttons);
        }
        printWindow.document.close();
        printWindow.print();
        if (isIOS) {
            return;
        }
        shouldClose = true;
        var id_1 = setInterval(function () {
            if (shouldClose && printWindow) {
                printWindow.close();
                clearInterval(id_1);
            }
        }, 300);
    }
}

export { printContent };
